import { render, staticRenderFns } from "./HomeAlignmentShareholder.vue?vue&type=template&id=f66c965e&scoped=true&"
import script from "./HomeAlignmentShareholder.vue?vue&type=script&lang=ts&"
export * from "./HomeAlignmentShareholder.vue?vue&type=script&lang=ts&"
import style0 from "./HomeAlignmentShareholder.vue?vue&type=style&index=0&id=f66c965e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66c965e",
  null
  
)

export default component.exports